// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Toasted from 'vue-toasted'
import vmodal from 'vue-js-modal'
import App from './App'
import router from './router'
import store from './store'
import VueProgressBar from 'vue-progressbar'
import vuescroll from 'vuescroll';
import 'vuescroll/dist/vuescroll.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import xoLoader from 'xo-loader';

// 配置百度编辑器
import '../static/ue/ueditor.config.js'
import '../static/ue/ueditor.all.js'
import '../static/ue/lang/zh-cn/zh-cn.js'
import '../static/ue/ueditor.parse.js'

// 引用全局变量文件
import global from './config/index.js'
// 引用工具文件
import utils from './utils/index.js'
// 引用API文件
import api from './api/index.js'
// 全局指令文件
import directives from './directives/directive.js'
// TOKEN处理文件
import varDeal from './utils/globalVar.js'
//  字体文件
import './assets/fonts/iconfont.css'
// 根据机构处理跳转
import orgurl from './utils/orgurl.js'

// import '@/router/permission.js' // 路由守卫，防止用户直接输入路由地址后进入页面
import '@/router/beforeRedirect.js'

// 将全局变量绑定到全局
Vue.prototype.$global = global
// 将工具方法绑定到全局
Vue.prototype.$utils = utils
// 将API方法绑定到全局
Vue.prototype.$api = api

Vue.prototype.$VD = varDeal

Vue.prototype.$OR = orgurl

Vue.config.productionTip = false
Vue.use(VueCookies)
Vue.use(Toasted, {
  position: 'top-center',
  duration: 5000,
  containerClass: 'xo-toast-container',
  className: 'xo-toast',
  singleton: true
})
Vue.use(vmodal, { dynamic: true, dialog: true })
Vue.use(VueProgressBar, global.progressBarOptions)
Vue.use(directives)
Vue.use(vuescroll)
Vue.use(ElementUI)
Vue.use(xoLoader)

/* eslint-disable */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js